import { Component, Input, OnInit } from '@angular/core';
import { StepHeaderItem } from '~components/step-header/step-header.component';

@Component({
  selector: 'app-step-header-step',
  templateUrl: './step-header-step.component.html',
  styleUrls: ['./step-header-step.component.scss'],
  standalone: false,
})
export class StepHeaderStepComponent implements OnInit {
  @Input()
  public stepItem: StepHeaderItem;

  constructor() {}

  ngOnInit(): void {}
}
